export default __webpack_public_path__ + "static/media/consolidlogo.0db26688.svg";